import { section } from "../components/dynamicEditor/components/portalDynamicComponent";
import { Settings } from "../models";
import { ActionButton } from "../models/settings";
import { useLocationPortalApi, useQueryWrapper } from "./locationPortalApi";
import { LOCATION, DYNAMIC_COMPONENTS, SETTINGS } from "./queries";

export function useSettingsApi() {
	const { Get } = useLocationPortalApi();

	/**
	 * Get the configuration settings from the controller
	 * @param branchId
	 */
	function getSettings(repId?: number, locationId?: number) {
		return Get<Settings>("GetSettings", { repId, locationId });
	}

	function getDynamicComponents() {
		return Get<section[]>("GetDynamicComponents").then(orderSections);
	}

	const useSettingsQuery = (repId?: number, locationId?: number) =>
		useQueryWrapper<Settings>([SETTINGS], [], () => getSettings(repId, locationId));

	const useDynamicComponentsQuery = () => useQueryWrapper<section[]>([DYNAMIC_COMPONENTS], [], getDynamicComponents);
	return { useSettingsQuery, useDynamicComponentsQuery };
}

function orderSections(sections: section[]) {
	if (!sections) return sections;
	for (const section of sections) {
		section.childSections?.sort((a, b) => a.ordinal - b.ordinal);
		section.components?.sort((a, b) => a.ordinal - b.ordinal);
		orderSections(section.childSections);
	}
	return sections;
}

export function useActionButtonsQuery(locationId: number) {
	const { Get } = useLocationPortalApi();
	return useQueryWrapper<ActionButton[]>(LOCATION.ACTION_BUTTONS, [locationId], () =>
		Get<ActionButton[]>("GetActionButtons", { locationId }),
	);
}
